import { useEffect, useState } from "react";
import { completeValueBlur, isCheckdAll, objectGenerator } from "../../../lib";
import useApprovalHours from "../../../store/useApprovalHours";
import IconButton from "../../../../../components/IconButton";
import { IconEye } from "../../../../../icons";
import { generatorId } from "../../../../../libs/key-generator";
import "../index.scss";
import { CalculateTheMonthOfWork } from "../../../lib/CalculateTheMonthOfWork";
import { formatMoney } from "../../../lib/formatMoney";
import { DateUtils } from "../../../lib/date.utils";
import { ModalDetailsTimesheet } from "../../../../../components/ModalDetailsTimesheet";
import { useHolidays } from "../../../../../libs/Holiday/getHolidays";
import details from "material-ui/svg-icons/image/details";
import { getWorkingDaysOfMonth } from "../../../../../utils/get-working-days-of-month";
import { getWithoutToken, urlApiTegra } from "../../../../../service/api";
import { filterValidHolidays } from "../../../../../utils/filter-valid-holidays";

const uuid = generatorId();

export interface HolidaysProps {
  id: number
  date: string
  name: string
  year: number
}

function TbodyComponent({ details, checkboxSelection, checkedAll }: any) {
  const { listRender, state, setListRender, orderByField, orderByFieldEditable, page, selectSize, monthAndYear } = useApprovalHours();
  const [holidays, setHolidays] = useState<HolidaysProps[]>([])

  const [year, month] = String(monthAndYear).split('-')
  
  const days = getWorkingDaysOfMonth(Number(year), Number(month))
  
  const numberOfHolidays = holidays.filter(holiday => {
    const [holidayOnMonth, _] = holiday.date.split('-')
    return holidayOnMonth === month
  }).length

  const workingDaysWithoutHolidays = days - numberOfHolidays

  const editable = orderByFieldEditable;
  const [listCheckbox, setListCheckbox] = useState(listRender);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [needSpinnerModal, setNeedSpinnerModal] = useState(false);
  const [modalValue, setModalValue] = useState({
    userId: 0,
    userName: "",
  });

  

  useEffect(() => {
    setNeedSpinner(false);
  }, [listCheckbox, listRender]);

  useEffect(() => {
    getWithoutToken(`${urlApiTegra}/holidays`)
      .then(data => {
        const validHolidays = filterValidHolidays(data) 
        setHolidays(validHolidays)
      })
      .catch(err => console.log(err))  
  }, [])

  useEffect(() => {
    const isChecked = checkedAll ? true : false;
    const newcheckList = listCheckbox?.map((item: any) => {
      return isCheckdAll(item, isChecked);
    });
    setListCheckbox(newcheckList);
    setListRender(newcheckList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedAll]);

  function thisRender(index: number) {
    const initialListRender = index < (page + 1) * selectSize;
    const endListRender = index >= page * selectSize;
    return initialListRender && endListRender;
  }

  function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
    const valueId = event.target.value;
    checkedListCheckbox(Number(valueId));
  }

  function checkedListCheckbox(id: number) {
    const newcheckList = listCheckbox?.map((item: any) => {
      const label = item.userId || item.id;
      if (Number(label) !== Number(id)) return item;
      const data = {
        ...objectGenerator(item),
      };
      return data;
    });

    setListRender(newcheckList);
    setListCheckbox(newcheckList);
  }

  function handleModalValue(row: any) {
    setNeedSpinnerModal(false);
    const data = {
      userId: row.userId,
      userName: row.userName,
    };
    setModalValue(data);
    setNeedSpinnerModal(true);
  }

  function exitModal() {
    setNeedSpinnerModal(false);
  }

  function handleOnBlur(event: any, index: number, setState?: any) {
    const replaceValue = (value) => Number(value.replace(" ", "").replace(",", "."));
    let { value } = event.target;

    if (value.includes("*")) {
      const [value1, value2] = value.split("*");
      let DayWorkedInHours = replaceValue(value1) * replaceValue(value2);
      value = DateUtils.convertNumberTimeToString(DayWorkedInHours);
    }

    const newValue = completeValueBlur(value);
    const newcheckList = listCheckbox?.map((item: any, i: number) => {
      if (i === index) {
        const valuePaymentAmount = CalculateTheMonthOfWork.getHoursPayForProject({ ...item, timeApproved: newValue }, "timeApproved", workingDaysWithoutHolidays);

        return {
          ...item,
          timeApproved: newValue,
          payment_amount: formatMoney(valuePaymentAmount),
        };
      }
      return item;
    });
    setListRender(newcheckList);
    setListCheckbox(newcheckList);
    if (setState) setState(newValue);
  }

  return (
    <>
      {listCheckbox?.length ? (
        <tbody>
          {needSpinnerModal && <div className="overlay" onClick={() => exitModal()}></div>}
          {needSpinnerModal && <ModalDetailsTimesheet exit={exitModal} period={monthAndYear} value={modalValue} />}
          {!needSpinner &&
            listCheckbox?.map((row: any, listCheckboxIndex: number) => {
              if (!thisRender(listCheckboxIndex)) return;
              return (
                <tr key={uuid.generator()}>
                  {checkboxSelection && (
                    <td key={uuid.generator()} className="checkboxRow font-poppins">
                      <input
                        className="checkboxInput"
                        checked={row.checked}
                        value={row.userId || row.id}
                        onChange={(event) => handleCheckboxChange(event)}
                        type="checkbox"
                      />
                    </td>
                  )}
                  {orderByField?.map((i: string) => {
                    if (i === "payment_amount" && state) return;
                    return editable.includes(i) && !row?.projectName?.includes("- Horas Adicionais") ? (
                      <td key={uuid.generator()} className="approvalHours">
                        <Input list={listCheckbox} index={listCheckboxIndex} onBlur={handleOnBlur} />
                      </td>
                    ) : i === "url_statement" ? (
                      <>
                        {row[i] ? (
                          <a href={row[i]} target="_blank" rel="noreferrer">
                            <IconButton icon={IconEye} className="justify-center text-primary" />
                          </a>
                        ) : (
                          <IconButton icon={IconEye} className="justify-center text-gray-700 disabled-icon" />
                        )}
                      </>
                    ) : (
                      <td
                        className={`${row[i] === row.projectName && "invisible-850px"} ${
                          row?.projectName?.includes("- Horas Adicionais") && i === "timeApproved" && "time-approved-center"
                        }`}
                        key={uuid.generator()}
                      >
                        {i === "payment_amount" ? `R$ ${row[i] || "0,00"}` : row[i]}
                      </td>
                    );
                  })}
                  {details && !row?.projectName?.includes("- Horas Adicionais") ? (
                    <td key={uuid.generator()}>
                      <IconButton className="iconEye" icon={IconEye} onClick={() => handleModalValue(row)} />
                    </td>
                  ) : (
                    <td></td>
                  )}
                </tr>
              );
            })}
        </tbody>
      ) : (
        <div className="nothing-list">
          <h1>Não há registros para a busca realizada.</h1>
        </div>
      )}
    </>
  );
}

export default TbodyComponent;

function Input({ onBlur, index, list }: any) {
  const [state, setState] = useState(list[index].timeApproved);
  return (
    <input
      className="font-poppins"
      onBlur={(event: any) => onBlur(event, index, setState)}
      value={state}
      onChange={(event) => {
        setState(event.target.value);
      }}
    />
  );
}
